export default "__VITE_ASSET__BJEtBUrx__"